import { Button, Modal, Typography } from 'antd';
import PropTypes from 'prop-types';

const { Text } = Typography;

const ActionConfirmationModal = ({
  isModalOpen,
  setIsModalOpen,
  actionType,
  selectedData,
  handleAction,
}) => {
  const userActionContent = {
    fetchClip: {
      title: 'Are you sure you want to fetch the selected clip?',
      content:
        'Your video clip will be retrieved from the cloud. It may take a moment. Please wait while we prepare it for display.',
      actionButton: 'Confirm and Fetch',
    },
    removeBookmark: {
      title: 'Are you sure you want to remove bookmark for the selected clip?',
      content: `The bookmark was added by ${selectedData?.book_marked_by}. Removing it will remove the bookmark for all the users.`,
      actionButton: 'Remove Bookmark',
    },
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleActionClick = () => {
    handleAction();
  };

  return (
    <Modal
      open={isModalOpen}
      centered
      title={userActionContent[actionType]?.title}
      className="delete-form-modal"
      destroyOnHidden
      footer={[
        <Button key="delete" type="primary" onClick={handleActionClick}>
          {userActionContent[actionType]?.actionButton}
        </Button>,
        <Button key="cancel" onClick={handleCancel}>
          Cancel
        </Button>,
      ]}
      closable={false}
    >
      <Text>{userActionContent[actionType]?.content}</Text>
    </Modal>
  );
};

ActionConfirmationModal.propTypes = {
  isModalOpen: PropTypes.bool.isRequired,
  setIsModalOpen: PropTypes.func.isRequired,
  actionType: PropTypes.string.isRequired,
  selectedData: PropTypes.object,
  handleAction: PropTypes.func.isRequired,
};

export default ActionConfirmationModal;
